import { useCallback, useState } from "react";
import { updateAndToggleSelectedItems } from "src/helpers/updateAndToggleSelectedItemsHelper";
import { AppInstance, AvailableAppInstanceFragment } from "src/types.g";

interface UseAppToggleSelectionProps {
  isMultipleSelect?: boolean;
  appInstances: AvailableAppInstanceFragment[] | undefined;
  callback: (ids: string[], selectedApps: AppInstance[]) => void;
}

export const getSelectedApps = ({
  appInstances,
  selectedArray,
}: {
  appInstances: AvailableAppInstanceFragment[];
  selectedArray: string[];
}): AvailableAppInstanceFragment[] => {
  return selectedArray.reduce(
    (allSelectedApps: AvailableAppInstanceFragment[], currentId) => {
      const appInstance = appInstances.find(
        (instance) => instance.id === currentId,
      );
      return appInstance ? [...allSelectedApps, appInstance] : allSelectedApps;
    },
    [],
  );
};

export const useAppToggleSelection = ({
  isMultipleSelect,
  appInstances,
  callback,
}: UseAppToggleSelectionProps) => {
  const [selectedApps, setSelectedApps] = useState<
    AvailableAppInstanceFragment[]
  >([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const onToggleSelection = useCallback(
    (app: AvailableAppInstanceFragment) => {
      if (!appInstances) return;

      const { selectedArray } = updateAndToggleSelectedItems(
        app.id,
        app,
        selectedIds,
        selectedApps,
        isMultipleSelect,
      );

      setSelectedIds(selectedArray);

      const newSelectedApps = getSelectedApps({
        selectedArray,
        appInstances,
      });

      setSelectedApps(newSelectedApps);
      callback(selectedArray, newSelectedApps as AppInstance[]);
    },
    [appInstances, callback, isMultipleSelect, selectedIds, selectedApps],
  );

  return {
    selectedApps,
    selectedIds,
    onToggleSelection,
  };
};
